// extracted by mini-css-extract-plugin
module.exports = {"title":"styles-module--title--u1a_Z","big":"styles-module--big--2j-aq","center":"styles-module--center--380Ch"};